module.exports = __webpack_public_path__ + "static/media/colicoli18.d0d13508.webp";